import { render, staticRenderFns } from "./ReportTableControls.vue?vue&type=template&id=b4848f04&"
import script from "./ReportTableControls.vue?vue&type=script&lang=js&"
export * from "./ReportTableControls.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports